<div
  style="height: 40px"
  class="hmn-row__align">
  <img src="../../../assets/imgs/logo/logo_placeholder.svg" />

  <div class="hmn-cursor__pointer hmn-row__align">
    <p class="hmn-margin__x2-left hmn-color__primary"><i> agency_name_1 </i></p>
    <mat-icon class="hmn-margin__x2-left hmn-color__primary"> arrow_drop_down </mat-icon>
  </div>
</div>
